import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './ServicesOverview.css';

// Existing images
import webImage from '../assets/foto_web.webp';
import kiImage from '../assets/team-office.webp';
import mobileImage from '../assets/mobile_1.webp';
import dataImage from '../assets/datenanylye3.png';
import officeImage from '../assets/office-multi-hero.webp';
import webSuccessImage from '../assets/Grafik.webp';
import tec1Image from '../assets/msvsgoogle.webp';
import tec2Image from '../assets/foto1.webp';

const SERVICE_ICONS = ['🌐', '🤖', '📱', '📊', '🎨', '🛒', '☁️', '🚀'];

const SERVICE_IMAGES = [
  webImage,
  kiImage,
  mobileImage,
  dataImage,
  webSuccessImage,
  officeImage,
  tec1Image,
  tec2Image,
];

function ServicesOverview() {
  const { t } = useTranslation();
  const servicesData = t('services_overview.services', { returnObjects: true });

  return (
    <section className="services-overview">
      <div className="services-overview-container">
        <motion.div
          className="services-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, cubicBezier: [0.23, 1, 0.32, 1] }}
        >
          <span className="section-label-overview">UNSERE LEISTUNGEN</span>
          <h2>{t('services_overview.title')}</h2>
          <p className="services-overview-subtitle">{t('services_overview.subtitle')}</p>
        </motion.div>

        <div className="service-cards-grid">
          {servicesData.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{
                duration: 0.7,
                delay: index * 0.1,
                cubicBezier: [0.23, 1, 0.32, 1]
              }}
            >
              <Link to={`/leistungen/${index + 1}`} className="service-card-link">
                <motion.div
                  className="service-card-new"
                  whileHover={{ y: -5 }}
                  transition={{ duration: 0.4, ease: "easeOut" }}
                >
                  <div className="foto1">
                    <img
                      src={SERVICE_IMAGES[index]}
                      alt={service.title}
                      className="service-card-img"
                    />
                    <div className="service-card-icon">{SERVICE_ICONS[index]}</div>
                  </div>
                  <div className="service-card-body">
                    <h3 className="service-card-title">{service.title}</h3>
                    <p className="service-card-description">{service.description}</p>
                    <div className="service-card-cta">
                      <span>Mehr erfahren</span>
                      <span className="cta-arrow">→</span>
                    </div>
                  </div>
                </motion.div>
              </Link>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="services-overview-cta"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <Link to="/leistungen" className="services-all-btn">
            {t('services_overview.cta_all')} →
          </Link>
        </motion.div>
      </div>
    </section>
  );
}

export default ServicesOverview;